<template>
  <!--    hero-area-start-->
  <div class="hero-area internet" style="background-image: url(assets/img/internet-hero-img.png)">
    <div class="container">
      <b-row>
        <b-col v-if="$route.meta.variant == 'digitalleaders'">
          <router-link to="/digitalleaders">
            <img :src="logo" alt="" width="350" />
          </router-link>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-lg-10 col-centered">
          <div class="hero-internet-containt">
            <h3>{{ title }}</h3>
            <center>
              <p class="subTitle">{{ subTitle }}</p>
            </center>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--    hero-area-end-->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    logo: {
      type: String,
      default: 'assets/img/logodl-2.png'
    }
  }
};
</script>

<style lang="scss" scoped>
.subTitle {
  width: 70%;
}
</style>
<style>
.col-centered {
  float: none;
  margin: 0 auto;
}
</style>
